export const SITE = {
  project: "Sugee Lake District",
  developer: "Sugee Group",
  domain: "sugee.co",
  phoneDisplay: "+91 84333 34441",
  phoneRaw: "+918433334441",
  whatsapp: "918433334441",
  whatsappMsg: "Hi, I'm interested in Sugee Lake District, Thane. Please share project details.",
  launchDate: "2026-08-30T00:00:00+05:30",
  email: "sales@sugee.co",
  logo: "/assets/sugee-logo.png",
  mark: "/assets/sugee-mark.png",
};

export const IMAGES = {
  hero: "/assets/elevation.jpg",
  elevation: "/assets/elevation.jpg",
  masterplan: "/assets/masterplan.jpg",
  elevTop: "/assets/elev-top.jpg",
  elevMid: "/assets/elev-mid.jpg",
  elevBase: "/assets/elev-base.jpg",
  elevDuo: "/assets/elev-duo.jpg",
  buildingAngle: "https://images.unsplash.com/photo-1443527394413-4b820fd08dde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnbGFzcyUyMHNreXNjcmFwZXIlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg2MjcwNDk5fDA&ixlib=rb-4.1.0&q=85",
  meetingRoom: "https://images.unsplash.com/photo-1706074740295-d7a79c079562?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBvZmZpY2UlMjBpbnRlcmlvciUyMG1vZGVybnxlbnwwfHx8fDE3ODYyNzA0OTl8MA&ixlib=rb-4.1.0&q=85",
  conference: "https://images.unsplash.com/photo-1706074793638-da28b90ea8ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBvZmZpY2UlMjBpbnRlcmlvciUyMG1vZGVybnxlbnwwfHx8fDE3ODYyNzA0OTl8MA&ixlib=rb-4.1.0&q=85",
  facade: "https://images.unsplash.com/photo-1481026469463-66327c86e544?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3R1cmFsJTIwZ2VvbWV0cmljJTIwZGV0YWlscyUyMGdsYXNzfGVufDB8fHx8MTc4NjI3MDQ5OXww&ixlib=rb-4.1.0&q=85",
  skyReflection: "https://images.unsplash.com/photo-1452696193712-6cabf5103b63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwZ2VvbWV0cmljJTIwZGV0YWlscyUyMGdsYXNzfGVufDB8fHx8MTc4NjI3MDQ5OXww&ixlib=rb-4.1.0&q=85",
};
